import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestFetchJBPSettings } from './api/requestFetchJBPSettings'
import { PARTNER360_JBP_SETTINGS_NAMESPACE } from './constants'
import { initialState } from './initialState'

const jbpSettingsSlice = createSlice({
  name: PARTNER360_JBP_SETTINGS_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(requestFetchJBPSettings.pending, (state) => {
        state.status = RequestStatus.PENDING
      })
      .addCase(requestFetchJBPSettings.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestFetchJBPSettings.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.data = action.payload
      }),
})

export default jbpSettingsSlice.reducer
